module.exports = {
  'en': {
    'HRAP32EC1': {
      '10': 'For Year',
      '20': 'App. No.',
      '30': 'For Department',
      '40': 'Position',
      '50': 'Or Fro Employee',
      '60': 'Approve By',
      '70': 'Approve Date',
      '80': 'Emp. Code',
      '90': 'Employee Name',
      '100': 'Department',
      '110': 'Position',
      '120': 'Position Date',
      '130': 'Approve Date',
      '151': 'Import KPI of Employee',
      '155': 'Import KPI of Employee',
      '160': 'Import File',
      '170': 'Delimitor',
      '180': 'Total No. of Transfer',
      '190': 'Record(s)',
      '200': 'Total No. of Error',
      '205': '(Download Sample)',
      '210': 'Record(s)',
      '220': 'List of not imported',
      '230': '(Download Sample)',
      '250': 'Description',
      '260': 'For year',
      '270': 'App. No.',
      '280': 'For Department',
      '290': 'Position',
      '300': 'Or For Employee'
    },
    'HRAP32EC2': {
      '10': 'For Year',
      '20': 'App. No.',
      '30': 'Employee Code',
      '40': 'Department',
      '50': 'Position',
      '60': 'KPI No.',
      '70': 'Description of KPI',
      '80': 'Weight'
    },
    'HRAP32EC5': {
      '10': 'Import of data can not be',
      '20': 'Text File Name',
      '30': 'Record',
      '40': 'Error Detail',
      '50': 'Data'
    },
    'HRAP32EP1': {
      '10': 'For Year',
      '20': 'App. No.',
      '30': 'Department',
      '40': 'Position',
      '50': 'Employee Code',
      '60': 'KPI No.',
      '70': 'Description of KPI',
      '80': 'Weight',
      '90': 'Target Value',
      '100': 'Target Date',
      '110': 'Units',
      '120': 'Metric Value',
      '130': 'List of work to do',
      '140': 'Item No',
      '150': 'Description',
      '155': 'Import KPI of Employee',
      '160': 'Import File',
      '170': 'Delimitor',
      '180': 'Total No. of Transfer',
      '190': 'Record(s)',
      '200': 'Total No. of Error',
      '210': 'Record(s)',
      '220': 'List of Unimport'
    },
    'HRAP32EP2': {
      '10': 'Ranking Condition',
      '20': 'No',
      '30': 'Ranking',
      '40': 'Achievement',
      '50': 'Ranking value',
      '60': 'From',
      '70': 'To',
      '80': 'Score'
    }
  },
  'th': {
    'HRAP32EC1': {
      '10': 'สำหรับปี',
      '20': 'ครั้งที่',
      '30': 'สำหรับหน่วยงาน',
      '40': 'ตำแหน่ง',
      '50': 'หรือ สำหรับพนักงาน',
      '60': 'อนุมัติโดย',
      '70': 'วันที่อนุมัติ',
      '80': 'รหัสพนักงาน',
      '90': 'ชื่อ - นามสกุล',
      '100': 'หน่วยงาน',
      '110': 'ตำแหน่ง',
      '120': 'วันที่เริ่มตำแหน่ง',
      '130': 'วันที่อนุมัติ',
      '151': 'Import ข้อมูล KPI ของพนักงาน',
      '155': 'Import ข้อมูล KPI ของพนักงาน',
      '160': 'Import File',
      '170': 'ตัวคั่น',
      '180': 'จำนวนข้อมูลที่ Transfer',
      '190': 'รายการ',
      '200': 'จำนวนข้อมูลที่ Error',
      '205': '(Download Sample)',
      '210': 'รายการ',
      '220': 'รายการข้อมูลที่ไม่สามารถ Import',
      '230': '(Download Sample)',
      '250': 'รายละเอียด',
      '260': 'สำหรับปี',
      '270': 'ครั้งที่',
      '280': 'สำหรับหน่วยงาน',
      '290': 'ตำแหน่ง',
      '300': 'หรือ สำหรับพนักงาน'
    },
    'HRAP32EC2': {
      '10': 'สำหรับปี',
      '20': 'ครั้งที่',
      '30': 'รหัสพนักงาน',
      '40': 'หน่วยงาน',
      '50': 'ตำแหน่ง',
      '60': 'ลำดับ KPI',
      '70': 'รายละเอียด KPI',
      '80': 'น้ำหนัก'
    },
    'HRAP32EC5': {
      '10': 'รายการข้อมูลที่ไม่สามารถ Import',
      '20': 'ชื่อ Text File',
      '30': 'บรรทัดที่',
      '40': 'รายละเอียด Error',
      '50': 'ข้อมูล'
    },
    'HRAP32EP1': {
      '10': 'สำหรับปี',
      '20': 'ครั้งที่',
      '30': 'หน่วยงาน',
      '40': 'ตำแหน่ง',
      '50': 'รหัสพนักงาน',
      '60': 'ลำดับที่ KPI',
      '70': 'รายละเอียด KPI',
      '80': 'น้ำหนัก',
      '90': 'เป้าหมายที่กำหนด',
      '100': 'วันที่กำหนดแล้วเสร็จ',
      '110': 'หน่วย',
      '120': 'มูลค่า',
      '130': 'รายละเอียดงานที่ต้องทำ',
      '140': 'ข้อที่',
      '150': 'รายละเอียด',
      '155': 'Import ข้อมูล KPI ของพนักงาน',
      '160': 'Import File',
      '170': 'ตัวคั่น',
      '180': 'จำนวนข้อมูลที่ Transfer',
      '190': 'รายการ',
      '200': 'จำนวนข้อมูลที่ Error',
      '210': 'รายการ',
      '220': 'รายการข้อมูลที่ไม่สามารถ Import'
    },
    'HRAP32EP2': {
      '10': 'เงื่อนไขการให้คะแนน',
      '20': 'ลำดับที่',
      '30': 'Ranking',
      '40': 'ผลงานที่ได้',
      '50': 'ช่วงมูลค่า',
      '60': 'ตั้งแต่',
      '70': 'ถึง',
      '80': 'คะแนนที่ได้'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hrms17e.js